module.exports = __webpack_public_path__ + "static/fluent-forever-a390e6e99cd0eb2cde1f046dbda8a021.jpg";